// ----------------------------------------------------------------------
// <copyright file="Izenda.IconDropdownSetting.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

/**
 * IconDropdownSetting component
 */
!(function() {
  var React = require('react');
  var observer = require('mobx-react').observer;
  var classnames = require('classnames');
  var FORMAT_CONFIG = require('logic/data/Izenda.ReportPartFormConstants').FORMAT_CONFIG;
  var { isNil } = require('lodash/fp');

  var IconDropdownSetting = React.createClass({
    propTypes: {
      onChange: React.PropTypes.func
    },

    handleSelectItem: function(item, type) {
      var props = this.props;
      var editorControl = props.editorControl;

      switch (type) {
        case 'numbered':
          editorControl && editorControl.applyListFormat('OL', item.value);
          props.applyListFormat && props.applyListFormat('OL', item.value);
          break;
        case 'bullet':
          editorControl && editorControl.applyListFormat('UL', item.value);
          props.applyListFormat && props.applyListFormat('UL', item.value);
          break;
        case 'repeater':
          editorControl && editorControl.updateRepeater(item.value);
          break;
        default:
          editorControl && editorControl.toggleFormat(item.value);
      }
    },

    renderOption: function(item, type) {
      var props = this.props;
      var classes = classnames(item.className, {
        active: !isNil(props.value) && (props.value[item.value] || props.value[type] === item.value)
      });

      return (
        <li key={item.value} className={classes}>
          <a onClick={this.handleSelectItem.bind(this, item, type)}>
            <i className={item.icon} />
            {item.label}
          </a>
        </li>
      );
    },

    renderOptions: function() {
      var items = [];
      var type = this.props.data.type;
      switch (type) {
        case 'heading':
          items = FORMAT_CONFIG.HEADING;
          break;
        case 'block':
          items = FORMAT_CONFIG.BLOCK;
          break;
        case 'numbered':
          items = FORMAT_CONFIG.NUMBER_LIST;
          break;
        case 'bullet':
          items = FORMAT_CONFIG.BULLET_LIST;
          break;
        case 'repeater':
          items = FORMAT_CONFIG.REPEATER_LIST;
          break;
      }

      return items.map(
        function(item) {
          return this.renderOption(item, type);
        }.bind(this)
      );
    },

    render: function() {
      var props = this.props;
      var data = props.data;

      return (
        <span className="izenda-FormSettings">
          <a
            ref={function(dom) {
              dom && $izenda(dom).dropdown();
            }}
            className="btn"
            data-toggle="dropdown"
            title={data.title}
          >
            <i className={data.className} />
            <span className="caret" />
          </a>
          <ul className="dropdown-menu">{this.renderOptions()}</ul>
        </span>
      );
    }
  });

  module.exports = observer(IconDropdownSetting);
})();



// WEBPACK FOOTER //
// ./ui/modules/ReportDesigner/Fields/ReportBody/ReportPartType/ReportPartForm/Izenda.IconDropdownSetting.jsx